// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"b47d2895c26dc53aa3dc","245":"f94f283bc9e12d248b9f","453":"f6d0f94b59551957c81f"}[chunkId] + ".js";
};